import Cookies from 'universal-cookie'
import { compress, decompress } from 'lzutf8'

import { workspaceDomainAttributesFromHostname } from 'utils/workspaceDomainUtils'

export const AUTH_COOKIE_KEY = 'almanac-editor-auth-new'

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const FRONTEND_URL = new URL(process.env.REACT_APP_FRONTEND_URL! as string)

const getCookieDomain = () => {
  const workspaceDomainAttributes = workspaceDomainAttributesFromHostname(window.getHostname())
  // NOTE:
  // * when on almanac.io: use .almanac.io
  // * when on subdomain.almanac.io: use .almanac.io
  // * when FRONTEND_URL is localhost: use localhost (so local development does still work)
  // * when on custom domain: use .custom.domain
  const hostname = window.getHostname()
  let domain = `.${hostname}`

  if (!workspaceDomainAttributes || workspaceDomainAttributes.subdomain) {
    domain = `.${FRONTEND_URL.hostname}`
  }

  if (FRONTEND_URL.hostname === 'localhost') {
    domain = 'localhost'
  }

  return domain
}
export const cookies = new Cookies()
export const cookieOptions = () => ({
  domain: getCookieDomain(),
  path: '/',
})

export const getCookie = (key: string) => {
  const value = cookies.get(key, { doNotParse: true })

  if (!value) return

  // NOTE: support non-compressed values, e.g. in tests and for old values
  try {
    return JSON.parse(value)
  } catch {}

  const decompressedValue = decompress(value, { inputEncoding: 'Base64' })
  try {
    return JSON.parse(decompressedValue)
  } catch {
    return decompressedValue
  }
}

export const authCookie = getCookie(AUTH_COOKIE_KEY)

export const removeCookie = (key: string) => cookies.remove(key, cookieOptions())

export const setCookie = (key: string, value: any) => {
  const stringValue = typeof value === 'string' ? value : JSON.stringify(value)
  const compressedValue = compress(stringValue, { outputEncoding: 'Base64' })

  cookies.remove(key)
  cookies.set(key, compressedValue, { ...cookieOptions(), maxAge: 30 * 24 * 60 * 60 })
}
